import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--currency-handler"
// Handles document currency changes and exchange rate visibility
export default class extends Controller {
  static targets = ["currency", "exchangeRateSection"]

  static values = {
    baseCurrency: {
      type: String,
      default: "EUR"
    }
  }

  static outlets = ["documents--totals-calculator"]

  connect() {
    if (this.hasCurrencyTarget) {
      // Set initial state
      this.#toggleExchangeRate(this.currencyTarget)

      // Create and store bound function reference for event listener
      this._onCurrencyChange = this.#onCurrencyChange.bind(this)

      // Listen for currency changes
      this.currencyTarget.addEventListener("change", this._onCurrencyChange)
    }
  }

  disconnect() {
    if (this.hasCurrencyTarget && this._onCurrencyChange) {
      this.currencyTarget.removeEventListener("change", this._onCurrencyChange)
      // Clear the stored reference so reconnects work correctly
      this._onCurrencyChange = null
    }
  }

  // Handle currency change
  #onCurrencyChange(event) {
    this.#toggleExchangeRate(event.target)
    // Notify totals calculator to recalculate with new currency
    this.#notifyTotalsCalculator()
  }

  // Toggle exchange rate row visibility based on currency
  #toggleExchangeRate(currencyElement) {
    if (!this.hasExchangeRateSectionTarget) {
      // Fallback: try to find exchange rate row by ID
      const exchangeRateSection = document.querySelector("#exchange_rate_section")
      if (!exchangeRateSection) {
        return // Exchange rate row doesn't exist in this form
      }
      const currency = currencyElement.value || currencyElement
      if (currency !== this.baseCurrencyValue) {
        exchangeRateSection.classList.remove("d-none")
      } else {
        exchangeRateSection.classList.add("d-none")
      }
      return
    }

    const currency = currencyElement.value || currencyElement
    if (currency !== this.baseCurrencyValue) {
      this.exchangeRateSectionTarget.classList.remove("d-none")
    } else {
      this.exchangeRateSectionTarget.classList.add("d-none")
    }
  }

  // Notify totals calculator of currency change
  #notifyTotalsCalculator() {
    if (this.hasDocumentsTotalsCalculatorOutlet) {
      const currency = this.hasCurrencyTarget ? this.currencyTarget.value : "EUR"
      // Update currency and recalculate via outlet
      this.documentsTotalsCalculatorOutlet.updateCurrency(currency)
    }
  }
}
